
import { getCustomer } from './get-customer';

const hideMessage = (message) => {
    message.style.display='none';
};

const showMessage = (message) => {
    message.style.display='block';
};

customElements.whenDefined('foxy-customer-portal').then( async () => {
    const portals = [...document.getElementsByTagName('foxy-customer-portal')];
    const login_message = document.getElementById(
        "js-foxy-login-message"
    );

    const logged_in_message = document.getElementById(
        "js-foxy-logged-in-message"
    );

    const user = await getCustomer();

    if(user) {
        showMessage(logged_in_message);
        hideMessage(login_message);
    } else {
        showMessage(login_message);
        hideMessage(logged_in_message);
    }

    portals.forEach(portal => {
        portal.addEventListener('signin', function () {
            hideMessage(login_message);
            showMessage(logged_in_message);
        });

        portal.addEventListener('signout', function () {
            showMessage(login_message);
            hideMessage(logged_in_message);
        });

        portal.addEventListener('signup', function () {
            hideMessage(login_message);
            showMessage(logged_in_message);
        });
    });
}); 